import { render, staticRenderFns } from "./positioning-device-fittings-type.vue?vue&type=template&id=70123cd2&scoped=true"
import script from "./positioning-device-fittings-type.vue?vue&type=script&lang=js"
export * from "./positioning-device-fittings-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70123cd2",
  null
  
)

export default component.exports